import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df6c825"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-title-new-button" }
const _hoisted_2 = { class: "table-header" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "first-column" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Confirmed")
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Remove", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "first-column" }
const _hoisted_11 = { class: "grid-item" }
const _hoisted_12 = { class: "grid-item" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]

import { PropType, computed, ref } from 'vue';
import GridMenu from '@/components/ui/grid/grid-menu.vue';
import { AppoinmentContactList } from '@/types/diary/AppointmentContactList';
import { AppointmentPropertyList } from '@/types/diary/AppointmentPropertyList';
import { ContextMenuItem } from '@/types/ui/menus/ContextMenuItem';
import { DxButton } from 'devextreme-vue';
import SwitchToggle from '@/components/ui/toggles/switch-toggle.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'attendee-property-list',
  props: {
    modelValue: {
        type: Array as PropType<AppoinmentContactList[] | AppointmentPropertyList[]>,
        required: true
    },
    /** 
     * Determines whether the specific contact is attendee.
     * @type {boolean}
     * @default true
     */
    isAttendee: {
        type: Boolean,
        default: true
    },
    /** 
     * The unique identifier for the attendee List Dropdown.
     * @type {string}
     * @default: 'attendee-types-menu'
     */
    attendeeListDropdownId: {
        type: String,
        default: 'attendee-types-menu'
    },
    /** 
     * Determines whether the control is read only.
     * @type {boolean}
     * @default false
     */
    readOnly: {
        type: Boolean,
        default: false
    }
},
  emits: ['deleteGridItem', 'itemClicked', 'createNewProperty', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



const menuAttendeeTypes = ref<ContextMenuItem[]>([
    { key: 'contact', text: 'Contact', icon: 'fas fa-search' },
    { key: 'me', text: 'Me', icon: 'fas fa-user' },
    { key: 'user', text: 'User', icon: 'fas fa-user-plus' }
]);



const gridItems = computed({
    get: () => props.modelValue,
    set: (value: AppoinmentContactList[] | AppointmentPropertyList[]) => emit('update:modelValue', value)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(props.isAttendee ? 'Attendees' : 'Properties'), 1),
      (props.isAttendee)
        ? (_openBlock(), _createBlock(GridMenu, {
            key: 0,
            "menu-items": menuAttendeeTypes.value,
            disabled: props.readOnly,
            onItemClicked: _cache[0] || (_cache[0] = (key) => emit('itemClicked', key)),
            "button-icon": "",
            "button-text": "Add",
            id: __props.attendeeListDropdownId
          }, null, 8, ["menu-items", "disabled", "id"]))
        : (_openBlock(), _createBlock(_unref(DxButton), {
            key: 1,
            text: "Add",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('createNewProperty'))),
            disabled: props.readOnly
          }, null, 8, ["disabled"]))
    ]),
    _createElementVNode("table", null, [
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("th", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(props.isAttendee ? 'Name' : 'Address'), 1)
        ]),
        _hoisted_6,
        (!props.readOnly)
          ? (_openBlock(), _createElementBlock("th", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: "content-row",
          key: index
        }, [
          _createElementVNode("td", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString('name' in item ? item.name : item.address), 1)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(SwitchToggle, {
                modelValue: item.confirmed,
                "onUpdate:modelValue": ($event: any) => ((item.confirmed) = $event),
                readOnly: props.readOnly,
                marginBottom: "0rem"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "readOnly"])
            ])
          ]),
          (!props.readOnly)
            ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                _createElementVNode("i", {
                  class: "fa-solid fa-trash delete-icon grid-item",
                  onClick: ($event: any) => (emit('deleteGridItem', item.id))
                }, null, 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})